let initialized = false;

export const pendoScript = () => {
	const script = document.createElement(`script`);
	const text = document.createTextNode(`(function(apiKey){
	(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
	v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
		o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
		y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
		z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
	})('209ceb10-1bd9-4d46-604f-d0b32469b5e3');`);
	script.appendChild(text);
	script.async = true;

	document.body.appendChild(script);
};

export const initPendo = (metaData) => {
	/*
        need to get the user info either
        in an API call to platform
		body or from API call

		The commented out meta data is not yet available from calling the,
		so for now it is commented out. Teams will have to uncomment
		these lines once [this ticket](https://jira.icims.net/browse/IGN-418) is complete.
    */

	if (typeof pendo === 'undefined' || typeof metaData === 'undefined') {
		// color is undefined
		return;
	}

	// eslint-disable-next-line no-undef
	pendo.initialize({
		visitor: {
			id: metaData.id,
			userId: metaData.userId,
			groupId: metaData.groupId,
			groupNickName: metaData.groupNickName,
			// isFullAccess: metaData.isFullAccess,
			// locale: metaData.locale,
			// isAdminUser: metaData.isAdminUser,
			topParentGroupNickName: metaData.topParentGroupNickName,
		},
		account: {
			id: metaData.accountId,
			// eslint-disable-next-line camelcase
			customer_name: metaData.customerName,
			// privateBuild: metaData.privateBuild,
			// internalBuild: metaData.internalBuild,
			releasePhase: metaData.releasePhase,
			salesforceAccountId: metaData.salesforceAccountId,
		},
	});
	initialized = true;
};

export const updatePendo = (metaData) => {
	/*
        need to get the user info either
        in an API call to platform
        body or from API call
    */

	if (typeof pendo === 'undefined' || typeof metaData === 'undefined') {
		// color is undefined
		return;
	}

	if (initialized) {
		// eslint-disable-next-line no-undef
		pendo.updateOptions({
			visitor: {
				id: metaData.id,
				userId: metaData.userId,
				groupId: metaData.groupId,
				groupNickName: metaData.groupNickName,
				topParentGroupNickName: metaData.topParentGroupNickName,
			},
			account: {
				id: metaData.accountId,
				// eslint-disable-next-line camelcase
				customer_name: metaData.customerName,
				releasePhase: metaData.releasePhase,
				salesforceAccountId: metaData.salesforceAccountId,
			},
		});
	}
};

export const track = (trackType, metadata) => {
	if (initialized) {
		// eslint-disable-next-line no-undef
		pendo.track(trackType, metadata);
	}
};
